import { render, staticRenderFns } from "./PagePremium.vue?vue&type=template&id=34f1434e&scoped=true&"
import script from "./PagePremium.vue?vue&type=script&lang=js&"
export * from "./PagePremium.vue?vue&type=script&lang=js&"
import style0 from "./PagePremium.vue?vue&type=style&index=0&id=34f1434e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1434e",
  null
  
)

export default component.exports